"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _command = _interopRequireDefault(require("@ckeditor/ckeditor5-core/src/command"));

var _toarray = _interopRequireDefault(require("@ckeditor/ckeditor5-utils/src/toarray"));

var _filerepository = _interopRequireDefault(require("@ckeditor/ckeditor5-upload/src/filerepository"));

var _utils = require("@ckeditor/ckeditor5-image/src/image/utils");

var _uuid = require("uuid");

var _strings = require("../../../../util/strings");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var GrooveImageUploadCommand = /*#__PURE__*/function (_Command) {
  (0, _inherits2["default"])(GrooveImageUploadCommand, _Command);

  var _super = _createSuper(GrooveImageUploadCommand);

  function GrooveImageUploadCommand() {
    (0, _classCallCheck2["default"])(this, GrooveImageUploadCommand);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(GrooveImageUploadCommand, [{
    key: "refresh",

    /**
     * @inheritDoc
     */
    value: function refresh() {
      var imageElement = this.editor.model.document.selection.getSelectedElement();
      var isImage = imageElement && imageElement.name === 'image' || false;
      this.isEnabled = (0, _utils.isImageAllowed)(this.editor.model) || isImage;
    }
    /**
     * Executes the command.
     *
     * @fires execute
     * @param {Object} options Options for the executed command.
     * @param {File|Array.<File>} options.file The image file or an array of image files to upload.
     */

  }, {
    key: "execute",
    value: function execute(options) {
      var editor = this.editor;
      var model = editor.model;
      var fileRepository = editor.plugins.get(_filerepository["default"]);

      var _editor$config$get = editor.config.get('grooveImagePluginConfig'),
          EDITOR_MAX_INLINE_IMAGE_SIZE = _editor$config$get.EDITOR_MAX_INLINE_IMAGE_SIZE,
          EDITOR_MAX_UPLOAD_SIZE = _editor$config$get.EDITOR_MAX_UPLOAD_SIZE,
          onInlineImageTooLarge = _editor$config$get.onInlineImageTooLarge,
          onFileTooLarge = _editor$config$get.onFileTooLarge; // eslint-disable-next-line no-restricted-syntax


      var _iterator = _createForOfIteratorHelper((0, _toarray["default"])(options.file)),
          _step;

      try {
        var _loop = function _loop() {
          var file = _step.value;

          if (file.size >= EDITOR_MAX_UPLOAD_SIZE) {
            onFileTooLarge(function (prevAttachments) {
              return [].concat((0, _toConsumableArray2["default"])(prevAttachments), [{
                error: "Attachment too large (max size ".concat((0, _strings.humanFileSize)(EDITOR_MAX_UPLOAD_SIZE), ")"),
                id: (0, _uuid.v4)(),
                name: file.name,
                type: file.type,
                size: file.size
              }]);
            });
          } else if (file.size > EDITOR_MAX_INLINE_IMAGE_SIZE) {
            onInlineImageTooLarge((0, _uuid.v4)(), file);
          } else {
            uploadImage(model, fileRepository, file);
          }
        };

        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }]);
  return GrooveImageUploadCommand;
}(_command["default"]); // Handles uploading single file.
//
// @param {module:engine/model/model~Model} model
// @param {File} file


exports["default"] = GrooveImageUploadCommand;

function uploadImage(model, fileRepository, file) {
  var loader = fileRepository.createLoader(file); // Do not throw when upload adapter is not set. FileRepository will log an error anyway.

  if (!loader) {
    return;
  }

  (0, _utils.insertImage)(model, {
    uploadId: loader.id,
    customClass: 'grv-figure-image',
    customImgClass: 'grv-inline-image',
    customDataOriginalFilename: file.name
  });
}
//# sourceMappingURL=grooveimagecommand.js.map